module.exports = "/_next/static/images/mc-8fb7d82c73e2af2d5b9d4058e0c16631.svg";